import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { ClipboardModule } from 'ngx-clipboard';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio'; 
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatTabsModule} from '@angular/material/tabs'; 
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';


/* import { CashierModule } from './cashier/cashier.module';
import { UtilisateurModule } from './utilisateur/utilisateur.module';
import { DashboardModule } from './dashboard/dashboard.module';*/
import { HeaderComponent } from './components/header/header.component'; 
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { QuickdropdownComponent } from './components/header/dropdown/quickdropdown/quickdropdown.component';
import { MenuComponent } from './components/menu/menu.component';
import { SublevelMenuComponent } from './components/menu/sublevel-menu.component';
import { CopyrightComponent} from './components/copyright/copyright.component';
import { MessagepopupComponent } from './components/messagepopup/messagepopup.component';
import { SpinnerComponent } from './components/spinner/spinner.component'
import { DataProductComponent } from './components/data-div/data-product/data-product.component';
import { ButtonComponent } from './components/button/button.component';
import { DataListComponent } from './components/data-list/data-list.component';
import { ListepopupComponent } from './components/listepopup/listepopup.component';
import { PaginationComponent } from './common/pagination/pagination.component';
import { TableHeaderSearchComponent } from './components/table-header-search/table-header-search.component';
import { MapDialogComponent } from './components/map-dialog/map-dialog.component';
import { AdressesListepopupComponent } from './components/adresseslistepopup/adresseslistepopup.component';
import { SettingiconComponent } from './components/header/menuicon/settingicon/settingicon.component';
import { SettingdropdownComponent } from './components/header/dropdown/settingdropdown/settingdropdown.component';
import { LogouticonComponent } from '../cashier/dashboard/menuicon/logouticon/logouticon.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ToastComponent } from './components/toast/toast.component';
import { TrackingMapComponent } from './components/tracking-map/tracking-map.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';


@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    DataProductComponent,
    ButtonComponent,
    QuickdropdownComponent,
    MenuComponent,
    DataListComponent,
    ListepopupComponent,
    SublevelMenuComponent,
    CopyrightComponent,
    MessagepopupComponent,
    PaginationComponent,
    TableHeaderSearchComponent,
    MapDialogComponent,
    AdressesListepopupComponent,
    SettingiconComponent,
    SettingdropdownComponent,
    LogouticonComponent,
    ConfirmDialogComponent,
    ToastComponent,
    TrackingMapComponent,
    SearchableSelectComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatSliderModule,
    RouterModule,
    FormsModule,
    ClipboardModule,
    MatIconModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatRadioModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    SpinnerComponent
/*     CashierModule,
    UtilisateurModule,
    DashboardModule */

  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    MatTooltipModule,
    HeaderComponent,
    SidebarComponent,
    DataProductComponent,
    ButtonComponent,
    QuickdropdownComponent,
    MenuComponent,
    DataListComponent,
    SublevelMenuComponent,
    CopyrightComponent,
    SpinnerComponent,
    MapDialogComponent,
    SettingiconComponent,
    SettingdropdownComponent,
    LogouticonComponent,
    ToastComponent,
    TrackingMapComponent,
    SearchableSelectComponent
  ],
  providers: [],
})
export class SharedModule { }